<template>
    <div>   
        <v-card class="mb-4">
            <v-row class="ml-1 mr-1">
                <v-col cols="11">
                    <v-card-title class="titulopagina">REGISTRO DE CONSUMOS</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                        <v-icon color="blue" large>help</v-icon>
                    </v-alert>
                </v-col>
            </v-row>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <!-- TABS CONSUMOS -->
        <v-card>
            <v-card-text>
                <v-card class="mt-2">
                    <template>
                        <v-tabs
                            fixed-tabs
                            background-color="cyan darken-3"
                            dark
                            v-model="tab"
                        >
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                            <v-tab key="rec_comb">
                                <v-card-title>
                                    Recepción Combustibles
                                </v-card-title>
                            </v-tab>
                            <v-tab key="cons_comb">
                                <v-card-title>
                                    Consumo Combustibles
                                </v-card-title>
                            </v-tab>
                            <v-tab key="cons_ener">
                                <v-card-title>
                                    Consumo Energías
                                </v-card-title>
                            </v-tab>
                        </v-tabs>
                    </template>

                    <v-tabs-items v-model="tab">
                        <template v-for="tab in tabs_info">
                            <tab-consumo
                                :tab_key="tab.tab_key"
                                :nombre_dato = "tab.nombre_dato"
                                :url_datos = "tab.url_datos"
                                :url_actualizar = "tab.url_actualizar"
                                :encabezado = "tab.encabezado"
                                :dato_default = "tab.dato_default"
                                :extra = "tab.extra"
                            ></tab-consumo>
                        </template>
                    </v-tabs-items>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
// Tabs
import TabConsumo from './TabConsumo.vue';

import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data() {
        return {
            tab: null,
            tipo_combustibles: [],
            tipo_energias: [],
            turnos: [],
        }
    },
    mounted() {
        this.cargarTurnos();
        this.cargarTipoCombustibles();
        this.cargarTipoEnergias();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Registro de Consumos`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran y registra la recepción de combustibles, el consumo de combustibles y el consumo de energía en general.`},
                {   tipo:`label`,   texto:`- El registro se divide en tres secciones para cada uno y las ventanas son similares en cada uno de estos, teniendo todas lo siguiente:`},
                {   tipo:`label`,   texto:`- En la ventana de la izquierda, se crea un nuevo registro de recepción/consumo rellenando cada campo solicitado (fecha, turno, tipo de combustible o energía, guía, cantidad o consumos y, opcionalmente, observación). Para guardar el registro, se deben rellenar todos los campos obligatorios (marcados con un *) y pulsar en el botón "Registrar".`},
                {   tipo:`label`,   texto:`- En la tabla de la derecha, se muestran todos los registros de recepciones o consumos existentes según el rango de fechas indicado arriba de la tabla. En la columna "Opciones", estos registros se pueden eliminar (pulsando en el botón con el icono de basura) o editar (pulsando el botón con el icono del lápiz). Al editar, se agregarán los datos de ese registro a la ventana de la izquierda para su edición. Al terminar de editar, se debe pulsar el botón "Modificar". En caso de que se desee cancelar la edición, se debe pulsar nuevamente el icono con el lápiz. Si se está editando un registro, se marcará esa completa fila en la tabla con un tono más oscuro para diferenciarlas del resto.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        cargarTipoCombustibles() {
            const url = `${this.base_url}tipo_combustibles`;
            this.axios.get(url,this.headers).then((res)=>{
                this.tipo_combustibles = res.data.data;
                console.log(this.tipo_combustibles);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        cargarTipoEnergias() {
            const url = `${this.base_url}tipo_energias`;
            this.axios.get(url,this.headers).then((res)=>{
                this.tipo_energias = res.data.data;
                console.log(this.tipo_energias);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        cargarTurnos() {
            const url = `${this.base_url}turnos`;
            this.axios.get(url,this.headers).then((res)=>{
                this.turnos = res.data.data.map(turno => {
                    turno.nombre = `${turno.nombre_turno} (${turno.hora_inicio.substring(0, turno.hora_fin.length - 3)} - ${turno.hora_fin.substring(0, turno.hora_fin.length - 3)})`;
                    return turno;
                });
            }).catch((error)=>{
                console.log('error',error);
            });
        }
    },
    computed:{
        tabs_info() {
            return [
                {
                    tab_key: "rec_comb",
                    nombre_dato: "Recepción de combustible",
                    url_datos: `${this.base_url}recepcion_combustibles`,
                    url_actualizar: `${this.base_url}recepcion_combustible`,
                    encabezado: [
                        { text: 'ID', align: 'center', sortable: true, value: 'id', type: "number", class: 'cabecera', hide_create: true},
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha', type: "date", class: 'cabecera',},
                        { text: 'Turno', align: 'center', sortable: true, value: 'turnos_id', type: "select", class: 'cabecera', use: "turnos"},
                        { text: 'Tipo de Combustible', align: 'center', sortable: true, value: 'tipo_combustibles_id', type: "select", use: "tipo_combustibles", class: 'cabecera'},
                        { text: 'Guía', align: 'center', sortable: true, value: 'documento', type: "text", class: 'cabecera', optional: true},
                        { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad', type: "number", class: 'cabecera',},
                        { text: 'Observación', align: 'center', sortable: true, value: 'observacion', type: "text", class: 'cabecera', optional: true},
                        { text: 'Opciones', value: 'actions', sortable: false, class: 'cabecera', hide_create: true},
                    ],
                    dato_default: {
                        id: 0,
                        fecha: new Date().toISOString().substring(0, 10),
                        tipo_combustibles_id: 1,
                        documento: "",
                        cantidad: null,
                        observacion: "",
                        turnos_id: 0,
                    },
                    extra: {
                        tipo_combustibles: this.tipo_combustibles,
                        turnos: this.turnos,
                    },
                },
                {
                    tab_key: "cons_comb",
                    nombre_dato: "Consumo de combustible",
                    url_datos: `${this.base_url}consumo_combustibles`,
                    url_actualizar: `${this.base_url}consumo_combustible`,
                    encabezado: [
                        { text: 'ID', align: 'center', sortable: true, value: 'id', type: "number", class: 'cabecera', hide_create: true,},
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha', type: "date", class: 'cabecera',},
                        { text: 'Turno', align: 'center', sortable: true, value: 'turnos_id', type: "select", class: 'cabecera', use: "turnos"},
                        { text: 'Tipo de Combustible', align: 'center', sortable: true, value: 'tipo_combustibles_id', type: "select", use: "tipo_combustibles", class: 'cabecera'},
                        { text: 'Guía', align: 'center', sortable: true, value: 'documento', type: "text", class: 'cabecera', optional: true},
                        { text: 'Consumo Planta Harina', align: 'center', sortable: true, value: 'consumo_l1', type: "number", class: 'cabecera'},
                        { text: 'Consumo Planta Hidrolizado', align: 'center', sortable: true, value: 'consumo_l3', type: "number", class: 'cabecera'},
                        { text: 'Observación', align: 'center', sortable: true, value: 'observacion', type: "text", class: 'cabecera', optional: true},
                        { text: 'Opciones', value: 'actions', sortable: false, class: 'cabecera', hide_create: true, width: "10%"},
                    ],
                    dato_default: {
                        id: 0,
                        fecha: new Date().toISOString().substring(0, 10),
                        tipo_combustibles_id: 1,
                        documento: "",
                        consumo_l1: null,
                        consumo_l3: null,
                        observacion: "",
                        turnos_id: 0,
                    },
                    extra: {
                        tipo_combustibles: this.tipo_combustibles,
                        turnos: this.turnos,
                    },
                },
                {
                    tab_key: "cons_ener",
                    nombre_dato: "Consumo de energía",
                    url_datos: `${this.base_url}consumo_energias`,
                    url_actualizar: `${this.base_url}consumo_energia`,
                    encabezado: [
                        { text: 'ID', align: 'center', sortable: true, value: 'id', type: "number", class: 'cabecera', hide_create: true,},
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha', type: "date", class: 'cabecera',},
                        { text: 'Tipo de Energía', align: 'center', sortable: true, value: 'tipo_energias_id', type: "select", use: "tipo_energias", class: 'cabecera'},
                        { text: 'Consumo', align: 'center', sortable: true, value: 'consumo', type: "number", class: 'cabecera'},
                        { text: 'Observación', align: 'center', sortable: true, value: 'observacion', type: "text", class: 'cabecera', optional: true},
                        { text: 'Opciones', value: 'actions', sortable: false, class: 'cabecera', hide_create: true},
                    ],
                    dato_default: {
                        id: 0,
                        fecha: new Date().toISOString().substring(0, 10),
                        tipo_energias_id: 1,
                        consumo: null,
                        observacion: "",
                    },
                    extra: {
                        tipo_energias: this.tipo_energias,
                    },
                },
            ]
        },
        ...mapState(['base_url', 'headers'])
    },
    components:{
        "tab-consumo": TabConsumo,
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda': ModalAyudas,
    },
}
</script>
<style>
    .row-seleccionada {
        background-color: gainsboro !important;
    }
</style>